"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordValidation = PasswordValidation;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PasswordValidation({
  password
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const has8Characters = password.length >= 8;
  const has1Number = password.match(/\d/);
  const has1Uppercase = password.match(/[A-Z]/);
  const has1Lowercase = password.match(/[a-z]/);
  const has1SpecialCharacter = password.match(/[\W_]/);
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    columnGap: 2,
    display: "flex",
    flexWrap: "wrap"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: has8Characters ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_characters'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: has1Number ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_digit'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: has1Uppercase ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_uppercase'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: has1Lowercase ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_lowercase'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: has1SpecialCharacter ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_special_character'))));
}